import { onUnmounted, ref, watch } from 'vue'

function useScrollShadow(scrollElement: HTMLElement | null, shadowElement: HTMLElement) {
    let listenerAdded = false
    const activeClass = ref<string | null>(null)

    const handleScrollShadow = (event: Event) => {
        const element = event.target as HTMLElement

        if (!element) return

        const { scrollTop, scrollHeight, clientHeight } = element

        // Check if the element's content is tall enough to add any shadow
        if (scrollHeight <= clientHeight) return

        // Check if the user has reached the top or bottom of the scroll
        if (scrollTop === 0) {
            activeClass.value = 'shadow-bottom'
        } else if (Math.ceil(scrollTop + clientHeight) >= scrollHeight) {
            activeClass.value = 'shadow-top'
        } else {
            // User is somewhere in the middle
            activeClass.value = 'shadow-mid'
        }
    }

    const addListener = (el: HTMLElement) => {
        el.addEventListener('scroll', handleScrollShadow)
        listenerAdded = true
        setTimeout(() => {
            handleScrollShadow({ target: scrollElement } as Event)
        }, 100)
    }

    if (scrollElement && !listenerAdded) {
        addListener(scrollElement)
    }

    if (shadowElement) {
        shadowElement.classList.add('scroll-shadow')
    }

    watch(activeClass, (curr, prev) => {
        if (prev) {
            shadowElement.classList.remove(prev)
        }
        if (curr) {
            shadowElement.classList.add(curr)
        }
    })

    onUnmounted(() => {
        shadowElement.removeEventListener('scroll', handleScrollShadow)
    })
}

export default useScrollShadow
